var React = require('react');

function ChevronsUpDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M84 64L68 80M68 80L52 64M68 80V16M12 32L28 16M28 16L44 32M28 16V80","stroke":"#130A09","strokeWidth":"8","strokeLinecap":"round","strokeLinejoin":"round"}));
}

ChevronsUpDown.defaultProps = {"width":"96","height":"96","viewBox":"0 0 96 96","fill":"none"};

module.exports = ChevronsUpDown;

ChevronsUpDown.default = ChevronsUpDown;
